function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "triangle icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Notifications",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Qronoport---Notifications",
  transform: "translate(-184.000000, -244.000000)",
  fill: "#06273A"
}, React.createElement("g", {
  id: "Group-10-Copy-5",
  transform: "translate(160.000000, 216.000000)"
}, React.createElement("path", {
  d: "M28.0711888,30.7621507 L32.667538,36.5198675 C32.8909992,36.799791 32.8164076,37.1874507 32.500933,37.3857298 C32.3826491,37.4600725 32.2412723,37.5 32.0963209,37.5 L22.9036224,37.5 C22.517023,37.5 22.2036224,37.2219167 22.2036224,36.8788836 C22.2036224,36.7502669 22.2486208,36.6248219 22.3324052,36.5198675 L26.9287545,30.7621507 C27.1522156,30.4822273 27.5891093,30.4160415 27.9045838,30.6143205 C27.9691333,30.6548906 28.0254662,30.7048753 28.0711888,30.7621507 Z",
  id: "triangle",
  transform: "translate(27.500000, 34.000000) rotate(-270.000000) translate(-27.500000, -34.000000) "
}))));

var SvgTriangle = function SvgTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/triangle.54004e43.svg";
export { ForwardRef as ReactComponent };